import { shareOrigin } from "@/lib/origin";
import { useState } from "react";
import { Loader2, Gift } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";
import { fill, shareOut } from "@/lib/partnerKit";
import { Section } from "@/components/partner/Section";

export default function GiftReset({ k, onSent }) {
  const g = k.copy.gift || {};
  const [busy, setBusy] = useState(null);
  const send = async (key, m) => {
    setBusy(key);
    try {
      const { data } = await api.post(`/resets/${m.reset}/share`);
      const url = `${shareOrigin()}${data.path}`;
      if (await shareOut({ text: fill(m.message, { name: k.name, link: "" }).trim(), url, title: k.resets[m.reset] })) onSent?.();
    } catch { toast.error("Couldn't create the gift. Please try again."); }
    finally { setBusy(null); }
  };
  return (
    <Section id="gift" eyebrow="Gift a Reset" title={g.headline || "Give someone 90 seconds."} sub={g.sub}>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {Object.entries(g.moments || {}).map(([key, m]) => (
          <button key={key} onClick={() => send(key, m)} disabled={!!busy} data-testid={`gift-moment-${key}`}
            className="group rounded-2xl border border-border bg-card/40 p-5 text-left hover:border-primary/50 hover:bg-primary/[0.05] transition-colors duration-200 disabled:opacity-60">
            <span className="flex items-center justify-between">
              <span className="font-serif text-xl">{m.label}</span>
              {busy === key ? <Loader2 className="w-4 h-4 animate-spin text-primary" /> : <Gift className="w-4 h-4 text-primary opacity-60 group-hover:opacity-100 transition-opacity" />}
            </span>
            <span className="block text-xs text-muted-foreground mt-1">{k.resets[m.reset] || "Reset"} · 90 seconds with Adelaida</span>
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-4">They hear it free, with almost no sales language. At the end: "{g.ending_title} {g.ending_sub}"</p>
    </Section>
  );
}
